<pxw-interactive-paycard
  [showSubmitButton]="false"
  [showCvvInput]="false"
  [cardModel]="cardModel"
  [showCreditCard]="showCreditCard"
  [showDocumentSelector]="true"
/>
